import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot } from '@angular/router';
import { CockpitFilterStateService } from '../services/cockpit-filter-state.service';

const GPS_FILTER_KEYS = ['id_plaque', 'id_affaire', 'id_affaire_only', 'id_point_relais', 'id_agent'];

/**
 * Guard qui maintient les filtres GPS (plaque, affaire, point de relais, agent) persistants
 * lors de la navigation entre les différentes pages de GPS.
 *
 * - Si l'URL n'a pas de paramètre GPS mais que le service a un état sauvegardé,
 *   redirige vers la même URL en ajoutant les paramètres GPS sauvegardés.
 * - Si l'URL a des paramètres GPS, les synchronise dans le service.
 * - Si l'utilisateur réinitialise le filtre (via CockpitFilterComponent.resetFilter()),
 *   le service est vidé et le guard laisse passer sans redirection.
 */
export const cockpitFilterGuard: CanActivateChildFn = (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const cockpitFilterState = inject(CockpitFilterStateService);
  const router = inject(Router);

  const params = childRoute.queryParams;
  const hasCockpitParam = GPS_FILTER_KEYS.some((key) => params[key]);

  if (hasCockpitParam) {
    // synchronisation avec les queryParams de l'URL
    const extracted = cockpitFilterState.extractFromQueryParams(params as Record<string, string>);
    cockpitFilterState.setState(extracted);
    return true;
  }

  if (cockpitFilterState.hasActiveState()) {
    const savedState = cockpitFilterState.getState();
    const urlPath = state.url.split('?')[0];

    router.navigate([urlPath], {
      queryParams: { ...params, ...savedState },
      replaceUrl: true,
    });
    return false;
  }

  return true;
};
